<template>
  <div>
    <div v-if="!hideRecords" v-show="showRecords" class="text-left">
      <button v-if="!data.locked" class="d-block btn btn-primary mb-2 btn-tracking" type="button"><i class="fa fa-plus mr-2"></i>Show Records</button>
      <div class="table-trackings-tables text-sm">
        <h4 class="mb-2 font-weight-bold">Invoices</h4>
        <div class="card mb-4">
          <table
            class="data-table table-invoices w-100"
            data-select="true"
            data-action="/api/report/invoices?type=status"
            data-post_data='{ "status_id": 0, "date": null, "placement_id": null }'
          >
            <thead>
              <td v-for="key in Object.keys(datatables.invoice.header)" :key="key" :data-column="key">{{ datatables.invoice.header[key] }}</td>
            </thead>
          </table>
          <div class="card-footer bg-secondary"></div>
        </div>

        <h4 class="mb-2 font-weight-bold">Payables</h4>
        <div class="card">
          <table
            class="data-table table-payables w-100"
            data-select="true"
            data-action="/api/report/payable?type=status"
            data-post_data='{ "status_id": 0, "date": null, "placement_id": null }'
          >
            <thead>
              <td v-for="key in Object.keys(datatables.payable.header)" :key="key" :data-column="key">{{ datatables.payable.header[key] }}</td>
            </thead>
          </table>
          <div class="card-footer bg-secondary"></div>
        </div>
      </div>
    </div>
    <div class="text-left my-4" v-if="!data.locked">
      <form id="statusForm" method="post" action="/api/placement_status/create" class="mb-5">
        <input type="hidden" name="placement_id" v-model="data.placement_id" />
        <input type="hidden" name="property_id" v-model="data.property_id" />
        <input type="hidden" name="lease_details_id" v-model="data.lease_details_id" />
        <input type="hidden" name="id" v-model="data.id" />
        <input type="hidden" name="date" v-model="activeDate" />

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-row mb-2">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Policyholder Name</label>
                  <div class="form-control-wrap text-lg">
                    {{ data.policyholder || "-" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-2">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Public Adjuster</label>
                  <div class="form-control-wrap text-lg">
                    {{ data.public_adjuster || "-" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-2">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Carrier Adjuster</label>
                  <div class="form-control-wrap text-lg">
                    {{ data.carrier_adjuster || "-" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-2">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Invoicing Preferences</label>
                  <div class="form-control-wrap text-lg">
                    {{ data.invoicing_preferences && data.invoicing_preferences != "null" ? data.invoicing_preferences : "-" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-2">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Insurance Company</label>
                  <div class="form-control-wrap text-lg">
                    {{ data.insurance_company || "-" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-2">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Checks Payable To</label>
                  <div class="form-control-wrap text-lg">
                    {{ data.payable_to ? data.payable_to : "-" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap mb-1">Insurance Prepaid Through</label>
                  <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                    <v-datepicker
                      type="text"
                      v-model="data.prepaid_through"
                      name="prepaid_through"
                      autocomplete="off"
                      class="form-control datepicker"
                      pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                      :options="dateConfig({ autofill: true, allowClear: true })"
                    ></v-datepicker>
                    <span class="form-control-date-custom"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col">
                <div class="form-group">
                  <label class=" mb-1">Insurance-Approved Extension Date</label>
                  <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                    <v-datepicker
                      type="text"
                      v-model="data.insurance_approved_extension_date"
                      name="insurance_approved_extension_date"
                      autocomplete="off"
                      class="form-control datepicker"
                      pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                      :options="dateConfig({ autofill: true, allowClear: true })"
                    ></v-datepicker>
                    <span class="form-control-date-custom"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap mb-1">Color Code</label>
                  <div class="colorpicker-container" style="text-align: start">
                    <div class="colorpicker" :data-color="data.color_code || 'rgba(0,0,0,0)'" style="position: relative">
                      <div class="colorpicker-inner" :style="`background-color: ${data.color_code || 'rgba(0,0,0,0)'}`"></div>
                      <input name="color_code" type="hidden" v-model="data.color_code" class="need-reload live-skip" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-row mb-3">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Property Specific Status Notes</label>
                  <div class="form-control-wrap">
                    <textarea
                      spellcheck="true"
                      name="note"
                      rows="6"
                      class="form-control alphanumeric-field ruled-textarea show-resize"
                      v-model="data.note"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mb-3">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Notes</label>
                  <div class="form-control-wrap">
                    <textarea
                      spellcheck="true"
                      name="status_notes"
                      rows="6"
                      class="form-control alphanumeric-field ruled-textarea show-resize"
                      v-model="data.status_notes"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row mb-3">
          <div class="col-12 mb-3 mb-lg-0 col-lg-6 paid-at-section-disabled" style="display: none;">
            <div class="form-row mb-3">
              <div class="col">
                <label class="tps-checkbox">
                  <input type="checkbox" disabled />
                  <span class="checkmark"></span>
                  <span class="label">Pay {{ defaultDate }}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3 mb-lg-0 col-lg-6 paid-at-section">
            <div class="row">
              <div class="col-12">
                <div class="form-row mb-3">
                  <div class="col">
                    <label class="tps-checkbox">
                      <input type="checkbox" name="paid_at" :checked="data.paid_at !== null" @change="showPayInfo = !showPayInfo" class="live-skip" />
                      <span class="checkmark"></span>
                      <span class="label">Pay {{ defaultDate }}</span>
                    </label>
                  </div>
                </div>
                <div class="form-row mb-3" v-show="showPayInfo">
                  <div class="col">
                    <div class="form-group">
                      <label class="form-control-wrap">Pay Amount</label>
                      <div class="form-control-wrap text-lg">
                        {{ data.pay_amount === null ? "-" : `$${formatMoney(data.pay_amount)}` }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row mb-2" v-show="showPayInfo">
                  <div class="col col-auto">
                    <div class="form-group">
                      <label class="form-control-wrap mb-1">Start Date</label>
                      <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                        <v-datepicker
                          type="text"
                          v-model="data.paid_start_date"
                          name="paid_start_date"
                          autocomplete="off"
                          class="form-control datepicker"
                          pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                          @input="calculatePayAmount()"
                          :options="dateConfig({ payable: true, limitMin: true, limitMax: true, autofill: 'start' })"
                        ></v-datepicker>
                        <span class="form-control-date-custom"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row mb-3" v-show="showPayInfo">
                  <div class="col col-auto">
                    <div class="form-group">
                      <label class="form-control-wrap mb-1">End Date</label>
                      <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                        <v-datepicker
                          type="text"
                          v-model="data.paid_end_date"
                          name="paid_end_date"
                          autocomplete="off"
                          class="form-control datepicker"
                          pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                          @input="calculatePayAmount()"
                          :options="dateConfig({ payable: true, limitMin: true, autofill: 'end' })"
                        ></v-datepicker>
                        <span class="form-control-date-custom"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row mb-3" v-show="showPayInfo">
                  <div class="col">
                    <div class="form-group">
                      <label class="form-control-wrap">Paid Notes</label>
                      <div class="form-control-wrap">
                        <textarea
                          spellcheck="true"
                          name="paid_notes"
                          rows="4"
                          class="form-control alphanumeric-field ruled-textarea show-resize"
                          v-model="data.paid_notes"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="vendors.length" class="col-12">
                <div v-for="vendor in vendors" class="mb-3" :key="vendor.id">
                  <div class="form-row mb-3">
                    <div class="col">
                      <label class="tps-checkbox">
                        <input
                          type="checkbox"
                          :name="`vendors[${vendor.id}][paid_at]`"
                          v-model="vendor.paid_at"
                          class="live-skip"
                          @change="getVendorFees(vendor.id)"
                        />
                        <span class="checkmark"></span>
                        <span class="label">Pay {{ defaultDate }} ({{ vendor.name }})</span>
                      </label>
                    </div>
                  </div>
                  <div class="form-row mb-3" v-show="vendor.paid_at">
                    <div class="col">
                      <div class="form-group">
                        <label class="form-control-wrap">{{ vendor.name }}</label>
                        <div class="form-control-wrap text-lg">
                          {{ vendor.pay_amount === null ? "-" : `$${formatMoney(vendor.pay_amount)}` }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mb-2" v-show="vendor.paid_at">
                    <div class="col col-auto">
                      <div class="form-group">
                        <label class="form-control-wrap mb-1">Start Date</label>
                        <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                          <v-datepicker
                            type="text"
                            v-model="vendor.paid_start_date"
                            :name="`vendors[${vendor.id}][paid_start_date]`"
                            autocomplete="off"
                            class="form-control datepicker"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                            @input="getVendorFees(vendor.id)"
                            :options="dateConfig({ limitMin: true, limitMax: true, autofill: 'start' })"
                          ></v-datepicker>
                          <span class="form-control-date-custom"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mb-3" v-show="vendor.paid_at">
                    <div class="col col-auto">
                      <div class="form-group">
                        <label class="form-control-wrap mb-1">End Date</label>
                        <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                          <v-datepicker
                            type="text"
                            v-model="vendor.paid_end_date"
                            :name="`vendors[${vendor.id}][paid_end_date]`"
                            autocomplete="off"
                            class="form-control datepicker"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                            @input="getVendorFees(vendor.id)"
                            :options="dateConfig({ limitMin: true, autofill: 'end' })"
                          ></v-datepicker>
                          <span class="form-control-date-custom"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mt-3 mb-2" v-show="vendor.paid_at">
                    <div class="col">
                      <div class="form-group">
                        <label class="form-control-wrap">Paid Notes</label>
                        <div class="form-control-wrap">
                          <textarea
                            spellcheck="true"
                            :name="`vendors[${vendor.id}][paid_notes]`"
                            rows="4"
                            class="form-control alphanumeric-field ruled-textarea show-resize"
                            v-model="vendor.paid_notes"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6 invoiced-at-section-disabled" style="display:none;">
            <div class="form-row mb-3">
              <div class="col">
                <label class="tps-checkbox">
                  <input type="checkbox" disabled />
                  <span class="checkmark"></span>
                  <span class="label">Invoice {{ defaultDate }}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6 invoiced-at-section">
            <div class="form-row mb-3">
              <div class="col">
                <label class="tps-checkbox">
                  <input
                    type="checkbox"
                    name="invoiced_at"
                    :checked="data.invoiced_at !== null"
                    @change="showInvoiceInfo = !showInvoiceInfo"
                    class="live-skip"
                  />
                  <span class="checkmark"></span>
                  <span class="label">Invoice {{ defaultDate }}</span>
                </label>
              </div>
            </div>
            <div class="form-row mb-3" v-show="showInvoiceInfo">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Invoice Amount</label>
                  <div class="form-control-wrap text-lg">
                    {{ data.invoice_amount === null ? "-" : `$${formatMoney(data.invoice_amount)}` }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mb-2" v-show="showInvoiceInfo">
              <div class="col col-auto">
                <div class="form-group">
                  <label class="form-control-wrap mb-1">Start Date</label>
                  <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                    <v-datepicker
                      type="text"
                      v-model="data.invoiced_start_date"
                      name="invoiced_start_date"
                      autocomplete="off"
                      class="form-control datepicker"
                      pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                      @input="calculateInvoiceAmount()"
                      :options="dateConfig({ invoiceable: true, limitMin: true, limitMax: true, autofill: 'start' })"
                    ></v-datepicker>
                    <span class="form-control-date-custom"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mb-3" v-show="showInvoiceInfo">
              <div class="col col-auto">
                <div class="form-group">
                  <label class="form-control-wrap mb-1">End Date</label>
                  <div class="form-control-wrap form-datepicker" style="max-width: 150px;">
                    <v-datepicker
                      type="text"
                      v-model="data.invoiced_end_date"
                      name="invoiced_end_date"
                      autocomplete="off"
                      class="form-control datepicker"
                      pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                      @input="calculateInvoiceAmount()"
                      :options="dateConfig({ invoiceable: true, limitMin: true, autofill: 'end' })"
                    ></v-datepicker>
                    <span class="form-control-date-custom"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mt-3 mb-2" v-show="showInvoiceInfo">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Invoiced Notes</label>
                  <div class="form-control-wrap">
                    <textarea
                      spellcheck="true"
                      name="invoiced_notes"
                      rows="4"
                      class="form-control alphanumeric-field ruled-textarea show-resize"
                      v-model="data.invoiced_notes"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mt-3 mb-2">
              <div class="col">
                <a v-if="data.pdf_path" target="_blank" :href="pdfPath">Download PDF</a>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="dropdown">
              <button
                type="button"
                class="btn px-2 py-1 btn-secondary dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa fa-plus"></i>
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item" @click="addRequest('paymentRequests')" type="button">Add Payment Request</button>
                <button class="dropdown-item" @click="addRequest('invoiceRequests')" type="button">Add Invoice Request</button>
              </div>
            </div>
          </div>

          <div class="col-6">
            <v-additional-status-request
              v-for="(item, index) in paymentRequests"
              :key="`pr-${item.id || item.tempId}`"
              :item="item"
              :index="index"
              :data="data"
            ></v-additional-status-request>
          </div>
          <div class="col-6">
            <v-additional-status-request
              v-for="(item, index) in invoiceRequests"
              :key="`ir-${item.id || item.tempId}`"
              :item="item"
              :index="index"
              :data="data"
              :is-invoice-request="true"
            ></v-additional-status-request>
          </div>
          <input type="hidden" id="payment_deleted_ids" name="payment_deleted_ids" v-model="deletedIds.paymentRequests" />
          <input type="hidden" id="invoice_deleted_ids" name="invoice_deleted_ids" v-model="deletedIds.invoiceRequests" />
        </div>
      </form>

      <div class="card-loader loading status-report-loading text-center" v-show="requestCounter">
        <div class="loading-spinner-circle">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="spinner-text">Fetching data...</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "defaultDate", "activeDate", "datatables", "hideRecords"],
  data() {
    return {
      showRecords: false,
      paymentRequests: [],
      invoiceRequests: [],
      vendors: [],
      requestCounter: 0,
      dateOptions: {},
      showPayInfo: this.data.paid_at !== null,
      showInvoiceInfo: this.data.invoiced_at !== null,
      deletedIds: {
        paymentRequests: "",
        invoiceRequests: ""
      }
    };
  },
  watch: {
    showPayInfo() {
      this.triggerUpdateActionButton();
    },
    showInvoiceInfo() {
      this.triggerUpdateActionButton();
    }
  },
  computed: {
    pdfPath() {
      return `${window.location.origin}/${this.data.pdf_path}`;
    }
  },
  methods: {
    addRequest(key) {
      this[key].push({
        tempId: `_${Math.random()
          .toString(36)
          .substr(2, 9)}`,
        start_date: this.startDate(this.activeDate),
        end_date: this.endDate(this.activeDate),
        what_for: "",
        amount: 0,
        invoiced_to_id: 1,
        invoiced_to: this.data.policyholder,
        payable_to_id: 1,
        payable_to: this.data.policyholder,
        payment_method_id: 1,
        notes: ""
      });
      this.triggerUpdateActionButton();
    },
    deleteRequest(key, index) {
      const item = this[key][index];

      if (!item) return;

      if (item.id) {
        this.deletedIds[key] = this.deletedIds[key] ? `${this.deletedIds[key]}${item.id}:` : `${item.id}:`;
      }

      this.$delete(this[key], index);
      this.triggerUpdateActionButton();
    },
    calculateInvoiceAmount() {
      const invoiced_start_date = this.data.invoiced_start_date;
      const invoiced_end_date = this.data.invoiced_end_date;
      const placement_id = this.data.placement_id;
      const property_id = this.data.property_id;

      $.ajax({
        url: "/api/placement_status/calculate_invoice_amount",
        method: "POST",
        data: { invoiced_end_date, invoiced_start_date, placement_id, property_id },
        dataType: "json",
        success: response => (this.data.invoice_amount = response.invoice_amount)
      });
    },
    calculatePayAmount() {
      const paid_start_date = this.data.paid_start_date;
      const paid_end_date = this.data.paid_end_date;
      const placement_id = this.data.placement_id;
      const property_id = this.data.property_id;

      $.ajax({
        url: "/api/placement_status/calculate_pay_amount",
        method: "POST",
        data: { paid_end_date, paid_start_date, placement_id, property_id },
        dataType: "json",
        success: response => (this.data.pay_amount = response.pay_amount)
      });
    },
    getVendorFees(id = null) {
      const paid_start_date = $(`#statusForm [name="vendors[${id}][paid_start_date]"]`).val();
      const paid_end_date = $(`#statusForm [name="vendors[${id}][paid_end_date]"]`).val();
      const placement_id = this.data.placement_id;
      const property_id = this.data.property_id;
      const status_id = this.data.id;

      $.ajax({
        url: "/api/placement_status/vendor_fees",
        method: "POST",
        data: { id, paid_end_date, paid_start_date, placement_id, property_id, status_id },
        dataType: "json",
        success: response => {
          if (response.vendors && response.vendors.length) {
            this.vendors = response.vendors.map(vendor => {
              let paid_start_date = vendor.paid_start_date;
              let paid_end_date = vendor.paid_end_date;
              let paid_at = !!vendor.paid_at;

              if (!this.isValidDate(paid_start_date)) paid_start_date = this.startDate(this.activeDate);
              if (!this.isValidDate(paid_end_date)) paid_end_date = this.endDate(this.activeDate);

              return { ...vendor, paid_at, paid_start_date, paid_end_date };
            });
          }

          if (response.vendor) {
            const index = this.vendors.findIndex(vendor => vendor.id == response.vendor.id);

            if (index === -1) return;

            this.vendors[index].pay_amount = response.vendor.pay_amount;
          }

          this.triggerUpdateActionButton();
        }
      });
    },
    getPaymentRequests(id) {
      if (!id) return;

      this.requestCounter++;

      $.ajax({
        url: `/api/placement_status/${id}/payables`,
        method: "POST",
        dataType: "json",
        success: response => {
          this.paymentRequests = response;
          this.requestCounter--;
          this.triggerUpdateActionButton();
        }
      });
    },
    getInvoiceRequests(id) {
      if (!id) return;

      this.requestCounter++;

      $.ajax({
        url: `/api/placement_status/${id}/invoices`,
        method: "POST",
        dataType: "json",
        success: response => {
          this.invoiceRequests = response;
          this.requestCounter--;
          this.triggerUpdateActionButton();
        }
      });
    },
    triggerUpdateActionButton() {
      $(".swal2-container .swal2-confirm").attr(
        "disabled",
        $("#statusForm input:checkbox:checked").length > 0 ||
          this.data.color_code !== "" ||
          this.paymentRequests.length ||
          this.invoiceRequests.length ||
          this.vendors.some(v => !!v.paid_at)
          ? null
          : "disabled"
      );
    },
    updateStatusColor(color) {
      // Transparent = No actions required
      if (color === "rgba(0, 0, 0, 0)" || color === "" || color === null) {
        $("#statusForm .paid-at-section").show();
        $("#statusForm .paid-at-section-disabled").hide();
        $("#statusForm .invoiced-at-section").show();
        $("#statusForm .invoiced-at-section-disabled").hide();

        return;
      }

      // Green = Good to Go
      // The option to save status, with or without pay and/or
      // with or without invoice option selected.
      else if (color === "rgb(0, 128, 0)") {
        $("#statusForm .paid-at-section").show();
        $("#statusForm .paid-at-section-disabled").hide();
        $("#statusForm .invoiced-at-section").show();
        $("#statusForm .invoiced-at-section-disabled").hide();

        return;
      }

      // Yellow = Waiting for Status
      // The option to save status, no option to pay and no option invoice.
      else if (color === "rgb(255, 255, 0)") {
        $("#statusForm .paid-at-section").hide();
        $("#statusForm .paid-at-section-disabled").show();
        $("#statusForm .invoiced-at-section").hide();
        $("#statusForm .invoiced-at-section-disabled").show();

        return;
      }

      // Blue = No Action Necessary
      // The option to save status, no option to pay and no option invoice.
      else if (color === "rgb(0, 0, 255)") {
        $("#statusForm .paid-at-section").hide();
        $("#statusForm .paid-at-section-disabled").show();
        $("#statusForm .invoiced-at-section").show();
        $("#statusForm .invoiced-at-section-disabled").hide();
        return;
      }

      // Red = Hold All Rents
      // No option to pay. Needs an option to invoice.
      else if (color === "rgb(255, 0, 0)") {
        $("#statusForm .paid-at-section").hide();
        $("#statusForm .paid-at-section-disabled").show();
        $("#statusForm .invoiced-at-section").show();
        $("#statusForm .invoiced-at-section-disabled").hide();

        return;
      }
    },
    initDataTable(selector, options) {
      const table = $(selector);
      if ($.fn.dataTable.isDataTable(table)) {
        table.DataTable().destroy();
        table.empty();
      }
      let html = "<thead><tr>";
      for (let i in options.header) {
        html += `<td data-column="${i}">${options.header[i]}</td>`;
      }
      html += "</tr></thead>";
      table.html(html);
      table.data("post_data", { status_id: options.status_id });
      table.data("options", options.options);
      window.dataTableInstance(table);
    },
    renderDataTables() {
      if (this.hideRecords) return;

      if (this.data.id && (this.data.invoices || this.data.payables)) {
        this.showRecords = true;

        this.initDataTable(".table-invoices", { ...this.datatables.invoice, status_id: this.data.id });
        this.initDataTable(".table-payables", { ...this.datatables.payable, status_id: this.data.id });

        if (!this.data.locked) $(".table-trackings-tables").slideUp(1000);
        return;
      }

      this.showRecords = false;
    },
    isValidDate(d) {
      return moment(d).format("MM/DD/YYYY") !== "Invalid date";
    },
    startDate(dateObj) {
      return moment(dateObj)
        .startOf("month")
        .format("MM/DD/YYYY");
    },
    endDate(dateObj) {
      return moment(dateObj)
        .endOf("month")
        .format("MM/DD/YYYY");
    },
    dateConfig({ payable, invoiceable, limitMin, limitMax, autofill, allowClear } = {}) {
      const instance = this;
      let disableDates = [];

      if (payable && this.dateOptions.hasOwnProperty("payableDates")) {
        if (this.dateOptions.payableDates !== false) {
          disableDates = [...this.getDisableDates(this.dateOptions.payableDates)];
        }
      }

      if (invoiceable && this.dateOptions.hasOwnProperty("invoiceDates")) {
        if (this.dateOptions.invoiceDates !== false) {
          disableDates = [...this.getDisableDates(this.dateOptions.invoiceDates)];
        }
      }

      return {
        minDate: limitMin ? this.startDate(instance.activeDate) : undefined,
        maxDate: limitMax ? this.endDate(instance.activeDate) : undefined,
        disableDates,
        open: function() {
          $(this)
            .closest(".form-datepicker")
            .addClass("active");
          $(this)
            .closest(".form-datepicker")
            .removeClass("success");

          if (instance.isValidDate($(this).val())) return;

          if (autofill) {
            let date = instance.activeDate;

            if (autofill === "start") date = instance.startDate(date);
            if (autofill === "end") date = instance.endDate(date);

            $(this).val(date);
          }
        },
        close: function() {
          if (!allowClear && !instance.isValidDate($(this).val())) {
            let date = instance.activeDate;

            if (autofill === "start") date = instance.startDate(date);
            if (autofill === "end") date = instance.endDate(date);

            $(this)
              .val(date)
              .trigger("change");
          }

          $(this)
            .closest(".form-datepicker")
            .removeClass("active");
          if ($(this).val() !== "") {
            $(this)
              .closest(".form-datepicker")
              .addClass("success");
          } else {
            $(this)
              .closest(".form-datepicker")
              .removeClass("success");
          }
        }
      };
    },
    getDisableDates(dateRanges) {
      let results = [];

      for (let i = 0; i < dateRanges.length; i++) {
        const dates = dateRanges[i];

        if (dates.completed) {
          const start_date = moment(dates.start_date).format("YYYY-MM-DD");
          const end_date = moment(dates.end_date).format("YYYY-MM-DD");
          let start = new Date(start_date);
          let end = new Date(end_date);
          while (start <= end) {
            results.push(moment(start).format("MM/DD/YYYY"));
            let newDate = start.setDate(start.getDate() + 1);
            start = new Date(newDate);
          }
        }
      }

      return [...new Set(results)];
    },
    formatMoney(amount) {
      return window.formatMoney(amount);
    },
    initColorPicker() {
      if (this.data.color_code === "rgba(0, 0, 0, 0)" || !this.data.color_code) this.data.color_code = "";

      const $statusForm = $("#statusForm");
      const palette = $(".colorpicker-palette");

      $statusForm.on("click", ".colorpicker", function(e) {
        e.stopPropagation();
        let position = this.getBoundingClientRect();

        if (palette.data("picker") == this) {
          palette.hide();
          palette.data("picker", null);
        } else {
          palette.css({
            "z-index": 9999,
            position: "absolute",
            display: "flex",
            top: position.bottom + "px",
            left: position.left + "px"
          });
          palette.data("picker", this);
        }
      });

      const v = this;
      palette.on("click", ".colorpicker-wrapper", function() {
        palette.hide();
        let picker = $(palette.data("picker"));
        picker.data("color", $(this).data("color"));
        v.data.color_code = picker.data("color");
        v.updateStatusColor(picker.data("color"));
        v.triggerUpdateActionButton();
      });
    },
    loadDates() {
      if (!this.isValidDate(this.data.paid_start_date)) {
        this.data.paid_start_date = this.startDate(this.activeDate);
      }
      if (!this.isValidDate(this.data.paid_end_date)) {
        this.data.paid_end_date = this.endDate(this.activeDate);
      }
      if (!this.isValidDate(this.data.invoiced_start_date)) {
        this.data.invoiced_start_date = this.startDate(this.activeDate);
      }
      if (!this.isValidDate(this.data.invoiced_end_date)) {
        this.data.invoiced_end_date = this.endDate(this.activeDate);
      }
    }
  },
  mounted() {
    this.initColorPicker();
    this.calculatePayAmount();
    this.calculateInvoiceAmount();
    this.getVendorFees();
    this.getPaymentRequests(this.data.id);
    this.getInvoiceRequests(this.data.id);
    this.updateStatusColor(this.data.color_code);
    this.renderDataTables();
    this.triggerUpdateActionButton();
    this.loadDates();

    try {
      this.dateOptions = {
        payableDates: this.data.payables ? JSON.parse(this.data.payables) : false,
        invoiceDates: this.data.invoices ? JSON.parse(this.data.invoices) : false
      };
    } catch (error) {
      this.dateOptions = {};
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reports/status-report.vue